new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      Position: 'fixed',
      useFirst: true, // first headerBar

      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;

      isNavUp: true,
      isNavMin: false,
      lastScrollTop: 0,
    },
    searchOpened: false,
  },
  computed: {
    headerClasses() {
      return {
        'nav-up': this.header.isNavUp,
        [this.header.Position]: true
      };
    }
  },
  created() {
    window.addEventListener("resize", this.screenHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.screenHandler);
  },
  methods: {
    setupMarquee() {
      const marquee = document.querySelector('.texto-header__list');
      if (!marquee) return;

      // Pega todos os itens originais
      const originalItems = Array.from(marquee.querySelectorAll('li'));
      const totalWidth = originalItems.reduce((acc, item) => acc + item.offsetWidth, 0);
      const screenWidth = window.innerWidth;

      // Calcula quantas vezes precisamos duplicar para garantir preenchimento
      const timesToDuplicate = Math.ceil((screenWidth) / totalWidth) + 1;

      // Limpa o marquee
      marquee.innerHTML = '';

      // Adiciona os itens duplicados
      for (let i = 0; i < timesToDuplicate; i++) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          marquee.appendChild(clone);
        });
      }

      // Ajusta a animação baseado no conteúdo total
      const finalWidth = marquee.scrollWidth;
      // Aumentando a velocidade da animação
      const duration = finalWidth / 20;

      marquee.style.animation = `none`;
      setTimeout(() => {
        marquee.style.animation = `marquee ${duration}s linear infinite`;
      }, 0);
    },
    cartPreview() {
      /// Verifica se a sessionStorage é suportada pelo navegador
      if (typeof (Storage) !== "undefined") {

        let url = window.location.href;
        let domain = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/img)

        let value = sessionStorage.getItem(`cart-preview-cache-${domain}`);
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          if (value !== null) {
            let ObjectValue = JSON.parse(value);
            let htmlItens = ObjectValue.html_itens
            let itensCartPreview = document.querySelector('.items_cart_preview');
            itensCartPreview.innerHTML = htmlItens
          } else {
            console.log("Não há valor armazenado para a chave fornecida.");
          }
        }

      } else {
        console.log("Desculpe, seu navegador não suporta sessionStorage.");
      }
    },

    screenHandler() {
      this.mobile = (window.innerWidth > 991) ? false : true;
    },

    addPaddingHeader() {
      const header = document.querySelector('header[data-role="heading"]');
      const headerHeight = header.clientHeight;
      const mainTag = document.querySelector('main[role="main"]');
      const bread = document.querySelector('.breadcrumb');
      const mainDiv = document.querySelector('.main-content');

      if (mainTag) {
        mainTag.style.paddingTop = `${headerHeight}px`;
      } else if (mainDiv && bread) {
        if (getComputedStyle(bread).display === 'none') {
          mainDiv.style.paddingTop = `${headerHeight}px`;
        } else {
          mainDiv.style.paddingTop = '0px';
          bread.style.marginTop = `${headerHeight}px`;
        }
      } else if (mainDiv) {
        mainDiv.style.paddingTop = `${headerHeight}px`;
      } else if (bread) {
        bread.style.marginTop = `${headerHeight}px`;
      }
    },

    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.button-busca').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },

    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      
      const isScrollingDown = st > this.lastScrollTop;
  
      // Quando o scroll está no topo da página
      if (st === 0) {
          this.header.isNavUp = true;
          this.header.isNavMin = false;
      } else if (isScrollingDown) {
          // Scroll para baixo
          this.header.isNavUp = false;
          this.header.isNavMin = true;
      } else {
          // Scroll para cima (mas não no topo)
          this.header.isNavUp = true;
          this.header.isNavMin = false;
      }
  
      this.lastScrollTop = st <= 0 ? 0 : st; // Evita valores negativos
  },
  },
  mounted() {
    this.setupMarquee();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
})

var cart_preview_triggers = $('.header__second--cart, .cart-preview-header__close, .cart-preview--overlay, .cart-preview .btn-continue, .header__second--tools-cart');

cart_preview_triggers.on("click", function (e) {
  e.preventDefault();
  $('.shoppub-fast-buy-popup').removeClass('active');
  $('.header__second--tools-cart-preview').toggleClass('active');
  $('.cart-preview').toggleClass('active');
  $('.cart-preview--overlay').toggleClass('active');
  document.body.classList.toggle('no-scroll');
});

$('.header__second--tools-search-mobile-icon').on('click', function (e) {
  $('.search').toggleClass('active');
  $('.header__search').toggleClass('active');
  $('.search__header').toggleClass('active');
});

$('.search').on('click', function (e) {
  if (e.target === this) {
    $('.search').removeClass('active');
    $('.header__search').removeClass('active');
    $('.search__header').removeClass('active');
  }
});

const mobileNav = document.querySelector('.mobile-nav');

if (mobileNav) {
  const syncMobileNavTrigger = () => {
    $('.js-mobile-nav-trigger i').toggleClass('active', mobileNav.classList.contains('active'));
  };

  new MutationObserver(syncMobileNavTrigger).observe(mobileNav, {
    attributes: true,
    attributeFilter: ['class'],
  });

  syncMobileNavTrigger();
}

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

